module.exports = __webpack_public_path__ + "static/media/ic_smarthouse.90a8dba9.png";